/**
 * @author xyguo
 * @description 岗位能力星级管理页面配置
 * @Date 2020/7/17
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../../tool';
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool


//配置项
export default (self, initialValue = {}, supplementary) => {
  let oper = []
  let btns = (self.getMenuBtn() || []).map((btn) => { return btn['code'] })
  if (btns.indexOf('update') !== -1 && btns.indexOf('enableOrDisable') !== -1) {
    oper.push(
      {
        title: '操作',
        tableItem: {
          width: 160,
          fixed: 'right',
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton tooltip="编辑" onClick={() => self._update(record)}>编辑</WizButton>
              <WizButton tooltip={record['state'] === 0 ? "启用" : "禁用"} onClick={() => self._changeState(record)}>
                {record['state'] === 0 ? "启用" : "禁用"}
              </WizButton>
            </WizDataTable.Oper>
          )
        }
      }
    )
  } else {
    if (btns.indexOf('update') !== -1) {
      oper.push(
        {
          title: '操作',
          tableItem: {
            width: 80,
            fixed: 'right',
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton tooltip="编辑" onClick={() => self._update(record)}>编辑</WizButton>
              </WizDataTable.Oper>
            )
          }
        }
      )
    } else if (btns.indexOf('enableOrDisable') !== -1) {
      oper.push(
        {
          title: '操作',
          tableItem: {
            width: 80,
            fixed: 'right',
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton tooltip={record['state'] === 0 ? "启用" : "禁用"} onClick={() => self._changeState(record)}>
                  {record['state'] === 0 ? "启用" : "禁用"}
                </WizButton>
              </WizDataTable.Oper>
            )
          }
        }
      )
    }
  }
  const columns = [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: "能力评估星级",
      name: "name",
      tableItem: {
        width: 270
      },
    },
    {
      title: "顺序",
      name: "sort",
      tableItem: {
        width: 80
      },
    },
    {
      title: "已评估人数",
      name: "studentCount",
      tableItem: {
        width: 120
      },
    },

    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' }
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: {
        width: 150,
      },
    },
    {
      title: "最新修改时间",
      name: "updateTime",
      tableItem: {
      },
    },
    ...oper
  ];
  return columns
}


